import {ListColumnsFactoryComponent, ListConfigFieldTypes} from '@src/@types/components/List';
import ListColumn from '@src/components/List/columns/ListColumn';
import NumberColumn from '@src/components/List/columns/NumberColumn';
import PriceColumn from '@src/components/List/columns/PriceColumn';
import SensitiveColumn from '@src/components/List/columns/SensitiveColumn';
import SummaryColumn from '@src/components/List/columns/SummaryColumn';
import SwitchColumn from '@src/components/List/columns/SwitchColumn';
import ImageColumn from '@src/components/List/columns/ImageColumn';
import DatetimeColumn from '@src/components/List/columns/DatetimeColumn';
import DateColumn from '@src/components/List/columns/DateColumn';
import TimeColumn from '@src/components/List/columns/TimeColumn';
import TimeSinceColumn from '@src/components/List/columns/TimeSinceColumn';
import TimeTenseColumn from '@src/components/List/columns/TimeTenseColumn';
import SelectColumn from '@src/components/List/columns/SelectColumn';
import SelectableColumn from '@src/components/List/columns/SelectableColumn';
import RelationColumn from '@src/components/List/columns/RelationColumn';
import ColorPickerColumn from '@src/components/List/columns/ColorPickerColumn';
import TextColumn from '@src/components/List/columns/TextColumn';

export const wellKnownColumns: Record<Partial<ListConfigFieldTypes>, ListColumnsFactoryComponent> = {
    'custom': ListColumn,
    'text': TextColumn,
    'number': NumberColumn,
    'price': PriceColumn,
    'sensitive': SensitiveColumn,
    'summary': SummaryColumn,
    'switch': SwitchColumn,
    'image': ImageColumn,
    'datetime': DatetimeColumn,
    'date': DateColumn,
    'time': TimeColumn,
    'time_since': TimeSinceColumn,
    'time_tense': TimeTenseColumn,
    'select': SelectColumn,
    'selectable': SelectableColumn,
    'relation': RelationColumn,
    'color_picker': ColorPickerColumn,
};
